import React from 'react';
import loadericon from '../assets/icon/spinner.gif';

/**
 *
 * @param string className: SCSS class for background color, intended to allow different background colors.
 */
const FullPageLoader = ({className= "background-general-950-opacity05"}) => {
    return (
        <div className={`loader_container ${className}`} id='overlay'>
            <div className='loader_div'>
                <img src={loadericon} alt='' width='80px' height='80px' />
            </div>
        </div>
    );
};

export default FullPageLoader;
